import firebase from 'firebase/compat/app'
import 'firebase/compat/messaging'

var firebaseConfig = {
    apiKey: "AIzaSyDOvRL0RVwMSLgtkgTP9dHkWx8ZP-GYVT8",
    authDomain: "sccaz-project.firebaseapp.com",
    projectId: "sccaz-project",
    storageBucket: "sccaz-project.appspot.com",
    messagingSenderId: "903870222085",
    appId: "1:903870222085:web:8b6bbd9d1b4c316c0c316c",
    measurementId: "G-FSGWQQS9DT"
}

firebase.initializeApp(firebaseConfig)

export default firebase.messaging()